import styled, { css } from 'styled-components';

export const Wrapper = styled.form``;

export const RememberAndRecover = styled.div`
  ${({ theme }) => css`
    margin-top: 2rem;
    margin-bottom: 4.4rem;

    display: flex;
    align-items: center;
    justify-content: space-between;

    label span,
    button {
      font-size: 1rem;
      color: #b3b3b3;
      font-weight: ${theme.font.weight.medium};
    }

    label {
      display: flex;
      align-items: center;

      input {
        margin-right: 0.8rem;
      }
    }
  `}
`;
